import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { BrandButton } from "@/components/PageHeader";
import { errMsg } from "@/lib/api";

export const ReasonDialog = ({ title, desc, confirmLabel, onConfirm, onClose, testId }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await onConfirm(reason.trim()); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid={testId}>
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle><DialogDescription>{desc}</DialogDescription></DialogHeader>
        <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason" data-testid={`${testId}-reason`} />
        <div className="flex justify-end gap-2">
          <BrandButton variant="outline" onClick={onClose} data-testid={`${testId}-cancel`}>Cancel</BrandButton>
          <BrandButton onClick={go} disabled={busy || reason.trim().length < 3} data-testid={`${testId}-confirm`}>{busy ? "Working…" : confirmLabel}</BrandButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const Tabs2 = ({ value, onChange, tabs, testId }) => (
  <div className="inline-flex rounded-full bg-[#F1F2F4] p-1 mb-4" role="tablist" data-testid={testId}>
    {tabs.map(([k, label]) => (
      <button key={k} role="tab" aria-selected={value === k} onClick={() => onChange(k)} data-testid={`${testId}-${k}`}
        className={`h-9 px-5 rounded-full text-sm font-semibold transition-colors ${value === k ? "bg-white text-[#111] shadow-sm" : "text-gray-500 hover:text-[#111]"}`}>{label}</button>
    ))}
  </div>
);
